export default {
  exactMeasurement: {
    id: 'exact_measurement',
  },
  variableMeasurements: {
    id: 'variable_measurements',
  },
};